import React, { Component } from 'react'

import { FI_HELP_URL } from 'config/env'
import qs from 'qs'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import styled from 'styled-components'

import DocumentsViewer from 'app/application_revamp/components/AttachmentViewerModal'
import shieldIcon from 'app/assets/icons/application-details/shield.svg'
import bankIcon from 'app/assets/icons/bank.svg'
import BaseIconAI from 'app/assets/icons/SmartDocs/BaseIconAI.svg'
import BottomButton from 'app/bond_cover/renters/sharedComponent/bottom_buttons_connection'
import BallotSubmitModal from 'app/components/Ballot/Modals/BallotSubmitModal'
import {
  Alert,
  AlertSensitiveInfo,
  Box,
  Button,
  Flex,
  Modal,
} from 'app/components/design-system-components'
import { BallotAlertDocumentUpload } from 'app/components/design-system-components/BallotAlertDocumentUpload'
import { Input } from 'app/components/design-system-components/inputs'
import { TagsInput } from 'app/components/design-system-components/inputs/TagsInput/TagsInput'
import { Text as SystemText } from 'app/components/design-system-components/typography'
import * as Display from 'app/components/display/display'
import SmartDocsAlertBox from 'app/components/display/smartdocs/alertbox'
import CorrectDocumentModal from 'app/components/display/smartdocs/correctDocumentModal'
import ProcessingDocuments from 'app/components/display/smartdocs/documents_processing_modal'
import EmpHistoryNotPresentModal from 'app/components/display/smartdocs/emp_history_not_present'
import IncorrectDocumentReuploadModal from 'app/components/display/smartdocs/incorrectDocumentReupload'
import * as NewForm from 'app/components/forms/forms'
import { ErrorBox } from 'app/components/forms/util'
import ProgressBarComponent from 'app/components/progress_bar/connection'
import Text from 'app/components/text/text'
import {
  incomeBankStatement,
  incomeGorvenmentBenefitTicked,
  incomeHeaderGuidance,
  incomePayslipsGuidance,
} from 'app/constants/application-settings.constants'
import { translateErrorCodeToMessage } from 'app/constants/error_messages'
import { theme } from 'app/match/applicationReportPDF/assets/theme'
import { warn as logWarn } from 'app/services/snugLogger'
import * as snugNotifier from 'app/services/snugNotifier'
import DocumentList from 'app/shared_components/document_list/document_list'
import * as Form from 'app/shared_components/form_component'
import getParameter from 'app/shared_components/parameter_parser'
import Header from 'app/shared_components/rental_reputation_header_connection'
import { history } from 'app/shared_components/router'
import UnsavedMessage from 'app/shared_components/unsaved_message'
import { applicationText } from 'app/sm/apply/apply_helper'
import {
  DocumentTypes,
  parseDataUtil,
  parseStringToNumber,
  shouldCurrencyUpdate,
  shouldRenderBankStatements,
  urlTo,
  wait,
} from 'app/sm/helpers'
import { FinancialInsightsAuditCard } from 'app/sm/proof_of_income/components/FinancialInsightsAuditCard'
import SelectInvestmentProfile, {
  InvProfileBothExistingAndPlanned,
  InvProfileExistingInvestor,
  InvProfileSelect,
} from 'app/sm/proof_of_income/components/SelectInvestmentProfile'
import {
  isAllSufficient,
  WarningModal,
} from 'app/sm/proof_of_income/components/WarningModal'
import { isAuditTombstone } from 'app/sm/proof_of_income/financialInsightsStatus.types'
import {
  postGenerateDownloadUrl,
  postGenerateTranslationPreview,
  postStagedBankStatementManualRedactions,
} from 'app/sm/proof_of_income/proof_of_income_access'
import RentalReputationHeaderReminder from 'app/sm/rental_reputation_shared_component/header_reminder_connection'
import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'
import {
  payslipReqOptions,
  requireBankStatementOptionsMap,
} from 'app/sm/team_viewing_preference/team_viewing_preference_const'
import {
  fetchAIAnalysisOfDocumentPoller,
  fetchAIAnalysisOfDocuments,
  postRenterConfirmation,
  undoRenterConfirmation,
} from 'app/utils/applications/proofofincome/api'
import {
  formatCurrency,
  formatPercentage,
  getMissingEssentialsLabel,
} from 'app/utils/financial/formatters'
import { MAX_ANNUAL_INCOME, MAX_WEEKLY_INCOME } from 'app/utils/numbers/helpers'
import { covertBoolStringToBool } from 'app/utils/strings/helpers'
import * as textHelpers from 'app/utils/text/helpers'
import { isFinancialInsightsSettingEnabled } from 'config/features'

const No = 1
const Yes = 2
const TRUE = 'true'
const FALSE = 'false'
const bankStatementRedactionStateReady = 'ready'

const getBankStatementRedactionBadge = (doc = {}) => {
  if (doc.redactionState === bankStatementRedactionStateReady) {
    return 'Redacted'
  }

  return ''
}

const shouldOpenBankStatementInDocumentsViewer = (doc = {}) =>
  doc.redactionState === bankStatementRedactionStateReady

const getBankStatementDocumentsForDisplay = (documents = []) =>
  (documents || []).map((document) => ({
    ...document,
    docBadge: getBankStatementRedactionBadge(document),
  }))

const REDACTED_BANK_STATEMENT_SAVED_MESSAGE = 'Changes saved to bank statement'
const REDACTED_STATEMENT_OPEN_FALLBACK_MESSAGE =
  'Could not open the redacted statement.'
const STAGED_BANK_STATEMENT_VIEWER_QUERY_PARAM = 'stagedBankStatementViewerKey'
// Must match STAGED_BANK_STATEMENT_VIEWER_STORAGE_PREFIX in
// v2/src/api/bankStatementStaging.ts — the v1 container cannot import from v2.
const STAGED_BANK_STATEMENT_VIEWER_STORAGE_PREFIX =
  'staged-bank-statement-viewer:'
const STAGED_BANK_STATEMENT_DEFAULT_FILENAME = 'bank-statement.pdf'

const StyledTagsInput = styled.div`
  & label {
    border-color: ${({ error }) =>
      error ? theme.colors.error400 : theme.colors.grey200} !important;
  }
`

const BankVerifiedCard = styled.div`
  border: 2px solid #22c55e;
  overflow: hidden;
  border-radius: 8px;
  margin-bottom: 20px;
`

const BankVerifiedHeader = styled.div`
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BankVerifiedHeaderLeft = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  column-gap: 10px;
  & > :first-child {
    grid-row: 1 / 3;
  }
`

const BankVerifiedCheckmark = styled.span`
  background: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
`

const BankVerifiedTitle = styled.div`
  color: #fff;
  font-weight: 700;
  font-size: 16px;
`

const BankVerifiedSubtitle = styled.div`
  color: rgba(255, 255, 255, 0.75);
  font-size: 11px;
`

const BankVerifiedBadge = styled.span`
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 100px;
`

const BankVerifiedBody = styled.div`
  padding: 16px 20px;
  background: #f0fdf4;
`

const BankVerifiedGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`

const BankVerifiedMetricLabel = styled.div`
  font-size: 11px;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 2px;
`

const BankVerifiedMetricValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #111827;
`

const BankVerifiedFooter = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #dcfce7;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BankVerifiedRemoveButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  font-size: 12px;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
`

// Mirrors the renter pre-submit `.fi-pm-bank-account` block (and the PM panel
// equivalent) so the V1 connected card surfaces the same source-of-truth bank
// info as the other panels. Update both call sites if the design tokens change.
const BankVerifiedAccountBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin: 0 0 12px 0;
  background: #f8f9fa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
`

const BankVerifiedAccountIcon = styled.img`
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`

const BankVerifiedAccountText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

const BankVerifiedAccountBankName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
`

const BankVerifiedAccountName = styled.div`
  font-size: 13px;
  color: #555;
  line-height: 1.3;
`

const BankConnectCard = styled.div`
  border: 1.5px solid #22c55e;
  border-radius: 8px;
  margin-bottom: 0;
  background: #ffffff;
  overflow: hidden;
`

const BankConnectHeader = styled.div`
  padding: 20px 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
`

const BankConnectIcon = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #dcfce7;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

function BankConnectIconSvg() {
  return (
    <svg
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      stroke="#16a34a"
      strokeWidth={2}
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11m16-11v11M8 14v3m4-3v3m4-3v3"
      />
    </svg>
  )
}

const BankConnectBody = styled.div`
  padding: 0 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
`

const BankConnectButton = styled.a`
  display: block;
  width: 100%;
  padding: 12px;
  background: #16a34a;
  color: #ffffff !important;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  border-radius: 8px;
  border: none;
  text-decoration: none !important;
  cursor: pointer;

  &:hover,
  &:focus {
    background: #15803d;
    color: #ffffff !important;
    text-decoration: none !important;
  }

  &[aria-disabled='true'] {
    opacity: 0.7;
    pointer-events: none;
  }
`

const BankConnectExplainer = styled.p`
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
`
BankConnectExplainer.displayName = 'BankConnectExplainer'

const FiTrustStrip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #6b7280;
`
FiTrustStrip.displayName = 'FiTrustStrip'

const OrUploadDivider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 16px 0;
  color: #9ca3af;
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e5e7eb;
  }
`
OrUploadDivider.displayName = 'OrUploadDivider'

/**
 * Pure presentational component for the renter bank-connect CTA card.
 * Extracted from ProofOfIncome.renderBankConnectCta for isolated testability.
 * Props:
 *   isRedirecting {boolean} — whether the bank-connect flow has started
 *   onConnectClick {Function} — click handler for the CTA button
 *   href {string} — href for the CTA anchor
 *
 * @exports BankConnectCta
 */
function BankConnectExplainerTooltip() {
  return (
    <ReactTooltip
      id="fi-explainer-tooltip"
      data-type="info"
      className="tool-tip-style"
      clickable
    >
      <span>
        We use Open Banking (CDR) to fetch a verified income summary from your
        bank. Snug never sees your transaction details — only the verified
        summary.
        {FI_HELP_URL && ' '}
        {FI_HELP_URL && (
          <a href={FI_HELP_URL} target="_blank" rel="noopener noreferrer">
            Learn more
          </a>
        )}
      </span>
    </ReactTooltip>
  )
}

function BankConnectCardHeader() {
  return (
    <BankConnectHeader>
      <BankConnectIcon>
        <BankConnectIconSvg />
      </BankConnectIcon>
      <BankConnectExplainer>
        Upload documents or instantly verify your income securely via open
        banking
        <i
          className="icon-help-outline fs16 gray-light-color ml5"
          data-testid="fi-explainer-help-icon"
          data-tooltip-id="fi-explainer-tooltip"
        />
        <BankConnectExplainerTooltip />
      </BankConnectExplainer>
    </BankConnectHeader>
  )
}

function BankConnectCardBody({ isRedirecting, onConnectClick, href }) {
  return (
    <BankConnectBody>
      <BankConnectButton
        href={href}
        data-testid="fi-connect-bank-cta"
        aria-disabled={isRedirecting}
        onClick={onConnectClick}
      >
        {isRedirecting ? 'Redirecting…' : 'Attach Bank Verified Income'}
      </BankConnectButton>
      <FiTrustStrip data-testid="fi-trust-strip">
        <img src={shieldIcon} alt="" aria-hidden="true" />
        <span>Snug does not receive transaction details.</span>
      </FiTrustStrip>
    </BankConnectBody>
  )
}

export function BankConnectCta({ isRedirecting, onConnectClick, href }) {
  return (
    <>
      <BankConnectCard>
        <BankConnectCardHeader />
        <BankConnectCardBody
          isRedirecting={isRedirecting}
          onConnectClick={onConnectClick}
          href={href}
        />
      </BankConnectCard>
      <OrUploadDivider>or upload documents</OrUploadDivider>
    </>
  )
}

// Local V2-aligned next-pay formatter; shared formatNextPay produces YYYY-MM-DD (UTC), not D MMM YYYY.
export function formatNextPayLocal(date, amount) {
  if (amount == null && date == null) return null
  const parsedDate = new Date(date)
  const formattedDate =
    date && !isNaN(parsedDate.getTime())
      ? parsedDate.toLocaleDateString('en-AU', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        })
      : null
  if (amount != null && formattedDate) {
    return `${formatCurrency(amount)} on ${formattedDate}`
  }
  if (amount != null) return formatCurrency(amount)
  return formattedDate
}

function MetricItem({ label, children }) {
  return (
    <div>
      <BankVerifiedMetricLabel>{label}</BankVerifiedMetricLabel>
      <BankVerifiedMetricValue>{children}</BankVerifiedMetricValue>
    </div>
  )
}

export const maxRetries = 10
let retries = 0
class ProofOfIncome extends Component {
  constructor(props) {
    super(props)
    // Disable the Next button only when there is an agencyGUID in the URL,
    // because that is the only path that triggers an async settings fetch.
    // Without an agencyGUID the fetch never runs, so there is nothing to wait
    // for and calling setState in componentDidMount would be a no-op that
    // triggers a redundant re-render (DeepSource JS-C1007).
    const { id: agencyGUID } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    this.state = {
      openModal: false,
      newPaySlipsUpdated: false,
      newBankStatementsUpdated: false,
      newOtherStatementsAdded: false,
      newGovernmentBenefitDocumentAdded: false,
      otherIncomeTicked: false,
      governmentBenefitTicked: false,
      incomeValues: {
        otherWeeklyIncome: 0,
        otherAnnualIncome: 0,
        governmentWeeklyBenefits: 0,
        governmentAnnualBenefits: 0,
      },
      errors: {
        otherWeeklyIncome: '',
        otherAnnualIncome: '',
        governmentWeeklyBenefits: '',
        governmentAnnualBenefits: '',
        propertyInvestmentsProfile: '',
        savingsBalance: '',
      },
      extraIncomeReferenceId: '',
      unsavedChanges: false,
      teamSettingInfo: {},
      disableNextButtonToFetchSettings: Boolean(
        agencyGUID && agencyGUID !== '',
      ),
      financialInsightsEnabled: false,
      financialInsightsCompleted: false,
      financialInsightsReport: null,
      financialInsightsDisconnecting: false,
      financialInsightsAudit: null,
      bankStatementRequire: false,
      payslipsCountRequired: false,
      payslipsDurationRequired: false,
      payslipsMinDuration: 0,
      agencyId: '',
      isRenterEmployed: true,
      propertyInvestmentsContact: null,
      propertyInvestmentsInformation: null,
      propertyInvestmentsPostcodes: [],
      propertyInvestmentsProfile: 0,
      isBallotApplication: false,
      isBallotSubmitModalOpen: false,
      isBallotSubmitting: false,
      isGovtInfoLearnMoreModalOpened: false,
      isIncorrectReuploadModalOpen: false,
      aiAnalysisModalOpen: false,
      fromApplication: false,
      aiAnalysisData: {},
      runPayslipsSmartAnalysis: false,
      employmentHistoryNotPresentModalOpen: false,
      employmenthistoryModalSkipped: false,
      processingDocumentsModalOpen: false,
      showDocumentsViewer: false,
      documentsViewerGUID: '',
      bankStatementRedactionEnabled: false,
      isConnectBankRedirecting: false,
      stagedDocumentsViewerAttachments: null,
      stagedBankStatementViewerContext: null,
    }
  }

  componentDidMount() {
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const {
      id: agencyGUID,
      ballot = false,
      applicationId = '',
    } = curQueries || {}
    if (ballot && ballot === 'true') {
      this.setState({
        isBallotApplication: true,
      })
    }

    this.openStagedBankStatementViewerFromQuery(curQueries)

    this.props.fetchProofOfIncome()
    this.props.fetchCompleteness()
    this.props
      .fetchExtraIncome()
      .then((result) => {
        if (result.guidID) {
          const {
            governmentAnnualBenefits,
            governmentWeeklyBenefits,
            guidID,
            optedToHaveGovernmentBenefits,
            optedToHaveOtherIncome,
            otherAnnualIncome,
            otherWeeklyIncome,
            optedToHavePropertyInvestor,
            propertyInvestmentsContact,
            propertyInvestmentsInformation,
            propertyInvestmentsPostcodes,
            propertyInvestmentsProfile,
            optedToHavePropertyOwnership,
            savingsBalance,
          } = result
          const savingsBalanceVal =
            Number(savingsBalance) === 0 ? '' : savingsBalance
          this.setState({
            extraIncomeReferenceId: guidID,
            otherIncomeTicked: optedToHaveOtherIncome,
            governmentBenefitTicked: optedToHaveGovernmentBenefits,
            optedToHavePropertyInvestor: optedToHavePropertyInvestor,
            optedToHavePropertyOwnership: optedToHavePropertyOwnership,
            propertyInvestmentsContact: String(propertyInvestmentsContact),
            propertyInvestmentsInformation: String(
              propertyInvestmentsInformation,
            ),
            propertyInvestmentsProfile,
            incomeValues: {
              governmentAnnualBenefits,
              governmentWeeklyBenefits,
              otherWeeklyIncome,
              otherAnnualIncome,
              savingsBalance: savingsBalanceVal,
            },
          })
          if (propertyInvestmentsPostcodes) {
            this.setState({
              propertyInvestmentsPostcodes: propertyInvestmentsPostcodes.map(
                (value) => ({
                  option: value,
                  optionMeta: { id: value, displayText: value },
                }),
              ),
            })
          }
        }
      })
      .catch((error) => {
        this.setState({
          apiError: error,
        })
      })

    this.props.retrieveReputationPreference().then(({ preference }) => {
      this.setState({
        isRenterEmployed: preference && preference.optInEmployed,
      })
    })

    if (agencyGUID && agencyGUID !== '') {
      this.setState({
        agencyId: agencyGUID,
        fromApplication: true,
      })
      const applicationGUID =
        applicationId && applicationId?.toString()?.split(',')[0]

      this.props
        .fetchTeamSettingInformation(agencyGUID, 'application,ai')
        .then((teamSettingInfo) => {
          if (teamSettingInfo) {
            this.setState({
              teamSettingInfo,
              disableNextButtonToFetchSettings: false,
              bankStatementRequire: covertBoolStringToBool(
                teamSettingInfo?.application?.bank_statement_require,
              ),
              payslipsCountRequired: covertBoolStringToBool(
                teamSettingInfo?.application?.payslips_require,
              ),
              payslipsDurationRequired: covertBoolStringToBool(
                teamSettingInfo?.application?.[
                  applicationsAttributesIDs.payslipsRequiredDurationEnabled
                ],
              ),
              payslipsMinDuration: parseStringToNumber(
                teamSettingInfo?.application?.[
                  applicationsAttributesIDs.payslipsRequiredDuration
                ],
              ),
            })
          }
        })
        .catch((error) => {
          this.setState({ error })
        })
        .finally(() =>
          this.setState({ disableNextButtonToFetchSettings: false }),
        )

      this.props
        .fetchTeamSettingInformation(agencyGUID, 'ai')
        .then((teamSettingInfo) => {
          if (
            isFinancialInsightsSettingEnabled() &&
            teamSettingInfo?.ai?.financial_insights_enabled === 'true'
          ) {
            this.setState({ financialInsightsEnabled: true })
          }
          if (
            teamSettingInfo?.ai?.bank_statement_redaction_enabled === 'true'
          ) {
            this.setState({ bankStatementRedactionEnabled: true })
          }
        })

      this.props.fetchApplication(applicationGUID)
    }
    // When applicationId is present but agencyGUID is absent, no settings
    // fetch runs. The constructor already initialises
    // disableNextButtonToFetchSettings to false in that case, so no
    // setState call is needed here.

    // Fetch financial insights status. When visiting /sm/income directly
    // (profile page) there is no application context, so this runs outside
    // the agencyGUID block above. When opened in an application context the
    // applicationId query param must be forwarded so the BE can gate the
    // response against the receiving agency's entitlement.
    if (isFinancialInsightsSettingEnabled()) {
      this.fetchFinancialInsightsStatus()
    }

    // Reset the redirecting flag when the user returns via the browser Back
    // button (bfcache restore fires a pageshow event with persisted=true).
    this.handleBankRedirectReset = () => {
      if (this.state.isConnectBankRedirecting) {
        this.setState({ isConnectBankRedirecting: false })
      }
    }
    window.addEventListener('pageshow', this.handleBankRedirectReset)
  }

  componentDidUpdate(prevProps) {
    const { applyRules = {} } = this.props
    const {
      section: {
        income: {
          runPayslipsSmartAnalysis = false,
          smartDocsForRentersEnabled = false,
        } = {},
      } = {},
    } = applyRules || {}
    if (
      prevProps.analysisJobID !== this.props.analysisJobID &&
      runPayslipsSmartAnalysis
    ) {
      const jobID = this.props.analysisJobID.analysisJobId
      if (jobID && smartDocsForRentersEnabled) {
        this.setState({
          disableNextButtonToFetchSettings: true,
          processingDocumentsModalOpen: true,
        })
        this.callPayslipsJobIDPoller(jobID)
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('pageshow', this.handleBankRedirectReset)
  }

  // Fetch /v2/financial-insights/status and reconcile component state with the
  // tombstone vs live branch. Called from componentDidMount and from the inline
  // disconnect button so the audit card surfaces immediately after revoke
  // without requiring a page refresh.
  // IMPORTANT: when opened in an application context the applicationId query
  // param must be forwarded so the BE can gate the response against the
  // receiving agency's entitlement.
  fetchFinancialInsightsStatus = () => {
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const { applicationId = '' } = curQueries || {}
    const applicationGUID =
      applicationId && applicationId?.toString()?.split(',')[0]
    const statusUrl = applicationGUID
      ? `${
          window.location.origin
        }/v2/financial-insights/status?applicationId=${encodeURIComponent(
          applicationGUID,
        )}`
      : `${window.location.origin}/v2/financial-insights/status`
    return fetch(statusUrl, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((result) => {
        const data = result?.data || result
        if (data && isAuditTombstone(data)) {
          this.setState({
            financialInsightsEnabled: true,
            financialInsightsCompleted: false,
            financialInsightsReport: null,
            financialInsightsAudit: data,
          })
        } else if (data?.session?.status === 'completed' && data?.report) {
          this.setState({
            financialInsightsEnabled: true,
            financialInsightsCompleted: true,
            financialInsightsReport: data.report,
            financialInsightsAudit: null,
          })
        }
      })
      .catch((err) => {
        // Best-effort — don't block page load, but log for debugging
        logWarn('[FinancialInsights] status fetch failed', { err })
      })
  }

  // Cmd/Ctrl/Shift-click opens in a new tab, middle-click opens in a new
  // tab/window — in those cases the current tab must not be left on the
  // "Redirecting…" state with `aria-disabled`. Only claim the redirecting
  // state for a plain primary-button click that actually navigates this tab.
  handleConnectBankClick = (e) => {
    if (this.state.isConnectBankRedirecting) {
      e.preventDefault()
      return
    }
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return
    }
    this.setState({ isConnectBankRedirecting: true })
  }

  openStagedBankStatementViewerFromQuery = (queries = {}) => {
    const viewerKey = queries?.[STAGED_BANK_STATEMENT_VIEWER_QUERY_PARAM]

    if (typeof viewerKey !== 'string' || !viewerKey) {
      return
    }

    // Guard against a crafted URL probing arbitrary same-origin storage keys.
    if (!viewerKey.startsWith(STAGED_BANK_STATEMENT_VIEWER_STORAGE_PREFIX)) {
      return
    }

    const rawPayload = window.localStorage.getItem(viewerKey)
    if (!rawPayload) {
      return
    }

    let payload
    try {
      payload = JSON.parse(rawPayload)
    } catch {
      return
    }

    const {
      blobGuid = '',
      filename = STAGED_BANK_STATEMENT_DEFAULT_FILENAME,
      propertyID = '',
      presignedUrl = '',
      redactedUrl = '',
      translationPreview = null,
    } = payload || {}

    if (!blobGuid || !propertyID || !redactedUrl) {
      return
    }

    if (presignedUrl) {
      this.setState({
        showDocumentsViewer: true,
        documentsViewerGUID: blobGuid,
        stagedDocumentsViewerAttachments: [
          {
            url: presignedUrl,
            sourceUrl: redactedUrl,
            name: filename,
            guidID: blobGuid,
            redactionState: bankStatementRedactionStateReady,
            typeOfDocument: 'Bank Statement',
            translationPreview,
          },
        ],
        stagedBankStatementViewerContext: {
          storageKey: viewerKey,
          propertyID,
          blobGuid,
          filename,
          redactedUrl,
          translationPreview,
        },
      })
      return
    }

    postGenerateDownloadUrl(redactedUrl)
      .then(({ ok, result, responseText, statusText }) => {
        if (!ok) {
          responseText
            .then((error) => {
              snugNotifier.error(
                translateErrorCodeToMessage(error || statusText),
              )
            })
            .catch(() => {
              snugNotifier.error(REDACTED_STATEMENT_OPEN_FALLBACK_MESSAGE)
            })
          return
        }

        this.setState({
          showDocumentsViewer: true,
          documentsViewerGUID: blobGuid,
          stagedDocumentsViewerAttachments: [
            {
              url: result?.presignedUrl || '',
              sourceUrl: redactedUrl,
              name: filename,
              guidID: blobGuid,
              redactionState: bankStatementRedactionStateReady,
              typeOfDocument: 'Bank Statement',
              translationPreview,
            },
          ],
          stagedBankStatementViewerContext: {
            storageKey: viewerKey,
            propertyID,
            blobGuid,
            filename,
            redactedUrl,
            translationPreview,
          },
        })
      })
      .catch(() => {
        snugNotifier.error(REDACTED_STATEMENT_OPEN_FALLBACK_MESSAGE)
      })
  }

  callPayslipsJobIDPoller = (jobID) => {
    fetchAIAnalysisOfDocumentPoller(jobID).then((result) => {
      if (retries < maxRetries) {
        if (result?.status === 500) {
          retries = 0
          this.setState(
            {
              uploadedDocs: result?.message?.docs,
            },
            () => {
              this.getAIAnalysisOfDocs()
            },
          )
        } else {
          wait(2000).then(() => {
            this.callPayslipsJobIDPoller(jobID)
          })
          retries += 1
        }
      } else {
        retries = 0
        this.setState({
          disableNextButtonToFetchSettings: false,
          processingDocumentsModalOpen: false,
        })
        snugNotifier.error('Error in fetching AI analysis')
      }
    })
  }

  getAIAnalysisOfDocs = () => {
    const { uploadedDocs } = this.state
    const { fromApplication = false } = this.state
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const { id: agencyGUID } = curQueries || {}

    if (fromApplication && uploadedDocs?.length > 0) {
      let docIDString = ''
      uploadedDocs.forEach((doc) => (docIDString += `document_ids=${doc}&`))
      docIDString = docIDString.replace(/&(\s+)?$/, '')

      fetchAIAnalysisOfDocuments(docIDString, agencyGUID)
        .then((data) => {
          let isDocumentValid = Object.values(data.analysis)
            .flat()
            .every((doc) => {
              return doc.is_valid
            })
          const invalidDocs = Object.keys(data.analysis).filter(
            (key) => !data.analysis[key]['is_valid'],
          )
          if (isDocumentValid) {
            this.setState({
              aiAnalysisModalOpen: true,
              aiAnalysisData: data,
            })
          } else {
            this.setState({
              isIncorrectReuploadModalOpen: true,
              incorrectDocuments: invalidDocs,
              aiAnalysisData: data,
            })
          }
        })
        .catch((error) => {
          snugNotifier.error(error?.message)
        })
        .finally(() => {
          this.setState({
            disableNextButtonToFetchSettings: false,
            processingDocumentsModalOpen: false,
          })
        })
    }
  }

  toggleAIAnalysisModal = () => {
    const { aiAnalysisModalOpen } = this.state
    this.setState({ aiAnalysisModalOpen: !aiAnalysisModalOpen })
  }

  onChangePropertyInvestor = () => {
    return (event) => {
      const { target } = event
      const { id } = target

      this.setState({
        ...this.state.optedToHavePropertyInvestor,
        optedToHavePropertyInvestor: Number(id),
        errors: {
          ...this.state.errors,
          optedToHavePropertyInvestor: ![Yes, No].includes(Number(id))
            ? 'Please select property investment option'
            : '',
        },
      })
    }
  }

  onChangePropertyOwnership = () => {
    return (event) => {
      const { target } = event
      const { id } = target

      this.setState({
        ...this.state.optedToHavePropertyOwnership,
        optedToHavePropertyOwnership: Number(id),
        errors: {
          ...this.state.errors,
          optedToHavePropertyOwnership: ![Yes, No].includes(Number(id))
            ? 'Please select property ownership option'
            : '',
        },
      })
    }
  }

  onChangeInvestmentProfile = (data) => {
    const { value } = data
    this.setState(
      {
        propertyInvestmentsProfile: value,
      },
      () => {
        if (
          value > InvProfileSelect &&
          value <= InvProfileBothExistingAndPlanned
        ) {
          this.setState({
            errors: {
              ...this.state.errors,
              propertyInvestmentsProfile: '',
            },
          })
        }
      },
    )
  }

  onChangePropertyInvestmentContact = () => {
    return (event) => {
      const { target } = event
      const { id } = target

      this.setState({
        propertyInvestmentsContact: id,
        errors: {
          ...this.state.errors,
          propertyInvestmentsContact: ![TRUE, FALSE].includes(id)
            ? 'Please select property investment contact option'
            : '',
        },
      })
    }
  }

  onChangePropertyInvestmentInformation = () => {
    return (event) => {
      const { target } = event
      const { id } = target

      this.setState({
        propertyInvestmentsInformation: id,
        errors: {
          ...this.state.errors,
          propertyInvestmentsInformation: ![TRUE, FALSE].includes(id)
            ? 'Please select property investment information option'
            : '',
        },
      })
    }
  }

  onChangePostcodesInput = (payload) => {
    const filteredCodes = payload.filter(
      (code) => /^[0-9]+$/.test(code.option) && code.option?.length <= 4,
    )

    this.setState({
      propertyInvestmentsPostcodes: filteredCodes,
      errors: {
        ...this.state.errors,
        propertyInvestmentsPostcodes: !filteredCodes.length
          ? 'Please enter at least one postcode'
          : '',
      },
    })
  }

  onCheckBoxTicked = (field) => {
    this.setState({
      [field]: !this.state[field],
      unsavedChanges: true,
    })
  }

  onModalSecondaryButtonClick = () => {
    const { addRentalReputationBackUrl } = this.props
    const { pathname, search } = window.location
    addRentalReputationBackUrl(pathname + search)
    this.processExtraIncome()
  }

  setBankStatementsChanged = (newBankStatementsAdded) => {
    this.setState({
      newBankStatementsUpdated: newBankStatementsAdded > 0,
    })
  }

  setGovernmentBenefitDocumentChanged = (newGovernmentBenefitDocumentAdded) => {
    this.setState({
      newGovernmentBenefitDocumentAdded: newGovernmentBenefitDocumentAdded > 0,
    })
  }

  setOtherIncomeStatementsChanged = (newOtherStatementsAdded) => {
    this.setState({
      newOtherStatementsAdded: newOtherStatementsAdded > 0,
    })
  }

  setPaySlipsChanged = (newPaySlipsAdded) => {
    this.setState({ newPaySlipsUpdated: newPaySlipsAdded > 0 })
  }

  employmentHistoryModalSkippedAction = () => {
    this.setState({
      employmenthistoryModalSkipped: true,
    })
  }

  toggleEmploymentHistoryNotPresentModal = () => {
    const { employmentHistoryNotPresentModalOpen } = this.state
    this.setState({
      employmentHistoryNotPresentModalOpen:
        !employmentHistoryNotPresentModalOpen,
    })
  }

  empHistoryNotPresentModalSecondaryAction = () => {
    const { employmenthistoryModalSkipped } = this.state
    if (!employmenthistoryModalSkipped) {
      this.employmentHistoryModalSkippedAction()
    } else {
      this.toggleEmploymentHistoryNotPresentModal()
      this.checkProofOfIncomeBeforeNext()
    }
  }

  empHistoryNotPresentModalPrimaryAction = () => {
    history.push(`${urlTo('EmploymentDetailsList')}${window.location.search}`)
  }

  getEffectiveBankStatementConfig = () => {
    const { config: applicationConfig = {} } =
      this.props.applicationDetails || {}
    const { teamSettingInfo, fromApplication } = this.state
    // Team settings API returns attribute values as strings; normalize only that path. application.config is already bools.
    const applicationsSettingsConfig =
      fromApplication && teamSettingInfo?.application
        ? parseDataUtil.convertObjValueFromStringToBoolean(
            teamSettingInfo.application,
          )
        : applicationConfig?.applicationsSettingsConfig || {}
    return {
      applicationsSettingsConfig,
      effectiveConfig: { applicationsSettingsConfig },
    }
  }

  checkProofOfIncomeBeforeNext = (
    payslipsNumber,
    bankStatementPeriodNumber,
    enforcePayslipRequirements,
  ) => {
    const {
      isRenterEmployed,
      isBallotApplication,
      otherIncomeTicked,
      governmentBenefitTicked,
      incomeValues: { savingsBalance },
      employmenthistoryModalSkipped,
    } = this.state
    const { addRentalReputationBackUrl, documents, applicationDetails } =
      this.props
    const { completeness = {}, isQLDForm22 } = this.props
    if (completeness) {
      const { employmentHistoryPresent = false } = completeness || {}
      if (
        !employmentHistoryPresent &&
        !employmenthistoryModalSkipped &&
        isRenterEmployed
      ) {
        this.setState({
          employmentHistoryNotPresentModalOpen: true,
        })
        return
      }
    }

    const { effectiveConfig } = this.getEffectiveBankStatementConfig()
    const shouldValidateBankStatements =
      shouldRenderBankStatements(effectiveConfig)

    const validHistory = isAllSufficient(
      documents,
      savingsBalance,
      otherIncomeTicked,
      governmentBenefitTicked,
      payslipsNumber,
      bankStatementPeriodNumber,
      enforcePayslipRequirements,
      isQLDForm22,
      shouldValidateBankStatements,
    )
    if (!validHistory && isRenterEmployed && !isBallotApplication) {
      this.toggleModal()
    } else {
      addRentalReputationBackUrl(
        `${window.location.pathname}${window.location.search}`,
      )
      this.processExtraIncome()
    }
  }

  processExtraIncome = () => {
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const { applicationId } = curQueries

    const { addExtraIncome, editExtraIncome, isQLDForm22 } = this.props
    const {
      otherIncomeTicked: optedToHaveOtherIncome,
      governmentBenefitTicked: optedToHaveGovernmentBenefits,
      incomeValues,
      extraIncomeReferenceId,
      optedToHavePropertyInvestor,
      propertyInvestmentsContact,
      propertyInvestmentsInformation,
      propertyInvestmentsPostcodes,
      propertyInvestmentsProfile,
      optedToHavePropertyOwnership,
      isBallotApplication,
      idDocsNotRequested = false,
      aiAnalysisModalOpen,
    } = this.state
    const {
      otherWeeklyIncome = 0,
      otherAnnualIncome = 0,
      governmentWeeklyBenefits = 0,
      governmentAnnualBenefits = 0,
      savingsBalance = 0,
    } = incomeValues
    const extraIncomeInfo = {
      optedToHaveOtherIncome: false,
      optedToHaveGovernmentBenefits: false,
      optedToHavePropertyInvestor: optedToHavePropertyInvestor,
      optedToHavePropertyOwnership: optedToHavePropertyOwnership,
      propertyInvestmentsContact: propertyInvestmentsContact === TRUE,
      propertyInvestmentsInformation: propertyInvestmentsInformation === TRUE,
      propertyInvestmentsPostcodes: propertyInvestmentsPostcodes.map(
        (tag) => tag.option,
      ),
      propertyInvestmentsProfile,
      isBallotApplication,
    }

    const validationErrors = this.state.errors

    if (!isQLDForm22) {
      if (!!savingsBalance && !Number(savingsBalance)) {
        validationErrors['savingsBalance'] =
          'Savings balance must be empty or greater than 0'
      } else if (!!savingsBalance) {
        Object.assign(extraIncomeInfo, {
          savingsBalance: Number(savingsBalance),
        })
      }
    }

    if (!isBallotApplication) {
      if (+optedToHavePropertyInvestor === Yes) {
        if (![TRUE, FALSE].includes(propertyInvestmentsContact)) {
          validationErrors['propertyInvestmentsContact'] =
            'Please select property investment contact option'
        }

        if (![TRUE, FALSE].includes(propertyInvestmentsInformation)) {
          validationErrors['propertyInvestmentsInformation'] =
            'Please select property investment information option'
        }

        if (!propertyInvestmentsPostcodes.length) {
          validationErrors['propertyInvestmentsPostcodes'] =
            'Postcodes are required'
        }
        if (
          propertyInvestmentsProfile < InvProfileExistingInvestor ||
          propertyInvestmentsProfile > InvProfileBothExistingAndPlanned
        ) {
          validationErrors['propertyInvestmentsProfile'] =
            'Investment Profile is required'
        }
      }
    }

    if (isBallotApplication) {
      if (![Yes, No].includes(optedToHavePropertyOwnership)) {
        validationErrors['optedToHavePropertyOwnership'] =
          'Please select property ownership option'
      }
      if (optedToHavePropertyOwnership === Yes) {
        validationErrors['optedToHavePropertyOwnership'] =
          'Property owners are not eligible for this affordable housing program'
      }
    }

    if (optedToHaveOtherIncome === true) {
      if (!Number(otherWeeklyIncome)) {
        validationErrors['otherWeeklyIncome'] =
          'Other weekly income cannot be empty or 0'
      }
      if (Number(otherWeeklyIncome) > MAX_WEEKLY_INCOME) {
        validationErrors['otherWeeklyIncome'] =
          'Other weekly income is exceeding maximum limit'
      }
      if (!Number(otherAnnualIncome)) {
        validationErrors['otherAnnualIncome'] =
          'Other annual income cannot be empty or 0'
      }
      if (Number(otherAnnualIncome) > MAX_ANNUAL_INCOME) {
        validationErrors['otherAnnualIncome'] =
          'Other annual income is exceeding maximum limit'
      }
      Object.assign(extraIncomeInfo, {
        optedToHaveOtherIncome,
        otherWeeklyIncome: Number(otherWeeklyIncome),
        otherAnnualIncome: Number(otherAnnualIncome),
      })
    }
    if (optedToHaveGovernmentBenefits === true) {
      if (!Number(governmentWeeklyBenefits)) {
        validationErrors['governmentWeeklyBenefits'] =
          'Government weekly benefits cannot be empty or 0'
      }
      if (Number(governmentWeeklyBenefits) > MAX_WEEKLY_INCOME) {
        validationErrors['governmentWeeklyBenefits'] =
          'Government weekly benefits is exceeding maximum limit'
      }
      if (!Number(governmentAnnualBenefits)) {
        validationErrors['governmentAnnualBenefits'] =
          'Other weekly income cannot be empty or 0'
      }
      if (Number(governmentAnnualBenefits) > MAX_ANNUAL_INCOME) {
        validationErrors['governmentAnnualBenefits'] =
          'Government annual benefits is exceeding maximum limit'
      }
      Object.assign(extraIncomeInfo, {
        optedToHaveGovernmentBenefits,
        governmentWeeklyBenefits: Number(governmentWeeklyBenefits),
        governmentAnnualBenefits: Number(governmentAnnualBenefits),
      })
    }

    const errMessages = Object.values(validationErrors)
      .map((errorValue, errorIndex) => {
        const errorKey = Object.keys(validationErrors)[errorIndex]
        if (
          !optedToHaveOtherIncome &&
          (errorKey === 'otherWeeklyIncome' || errorKey === 'otherAnnualIncome')
        ) {
          return ''
        }

        if (
          !optedToHaveGovernmentBenefits &&
          (errorKey === 'governmentAnnualBenefits' ||
            errorKey === 'governmentWeeklyBenefits')
        ) {
          return ''
        }
        return errorValue
      })
      .filter((message) => {
        return !!message.length
      })

    if (!!errMessages.length) {
      snugNotifier.error(errMessages[0])
      this.switchOffModal()
      return
    }
    this.setState({ errors: validationErrors })

    if (applicationId?.length > 0) {
      extraIncomeInfo['applicationGUID'] = Array.isArray(applicationId)
        ? applicationId[0]
        : applicationId
    }
    // should go to edit if extraIncomeReferenceId present
    if (
      (optedToHaveOtherIncome ||
        (!isQLDForm22 && !!savingsBalance) ||
        optedToHaveGovernmentBenefits ||
        (!isBallotApplication && optedToHavePropertyInvestor === Yes) ||
        (isBallotApplication && optedToHavePropertyOwnership === Yes)) &&
      !extraIncomeReferenceId
    ) {
      addExtraIncome(extraIncomeInfo)
        .then((result) => {
          this.setState(
            {
              unsavedChanges: false,
            },
            () => {
              if (!isBallotApplication) {
                history.push(
                  `${urlTo('identityDocument')}${window.location.search}`,
                )
              }
            },
          )
        })
        .catch((error) => {
          snugNotifier.error(error)
          this.switchOffModal()
        })
    } else if (extraIncomeReferenceId) {
      editExtraIncome(extraIncomeReferenceId, extraIncomeInfo)
        .then((result) => {
          this.setState(
            {
              unsavedChanges: false,
            },
            () => {
              if (!isBallotApplication) {
                history.push(
                  `${urlTo('identityDocument')}${window.location.search}`,
                )
              }
            },
          )
        })
        .catch((error) => {
          snugNotifier.error(error)
          this.switchOffModal()
        })
    } else {
      if (!isBallotApplication) {
        this.setState(
          {
            unsavedChanges: false,
          },
          () => {
            history.push(
              `${urlTo('identityDocument')}${window.location.search}`,
            )
          },
        )
      }
    }
    if (isBallotApplication) {
      this.setState({
        isBallotSubmitModalOpen: true,
      })
      // }
    }
  }

  toggleBallotSubmitModal = () => {
    const { isBallotSubmitModalOpen } = this.state
    this.setState({
      isBallotSubmitModalOpen: !isBallotSubmitModalOpen,
    })
  }

  submitBallotApplication = () => {
    const { submitFinalApplication, acceptJointApplicationAsSecondary } =
      this.props
    const curQueries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const {
      applicationId = '',
      fromSecondary = false,
      applicantGUID = '',
    } = curQueries
    let finalisedApplicationID = ''
    if (applicationId && Array.isArray(applicationId)) {
      finalisedApplicationID = applicationId[0]
    } else {
      finalisedApplicationID = applicationId
    }
    this.setState({
      isBallotSubmitting: true,
    })
    if (!fromSecondary) {
      submitFinalApplication(finalisedApplicationID, {
        isPrimary: true,
        optedToAcceptCondition: true,
        propertyInspectionType: 2,
        optedToAcceptDisclosureConsent: true,
        isBallotEntry: true,
      })
        .then(() => {
          history.push(
            `${urlTo('applyConfirmationSummaryBallot', {
              applicationId: finalisedApplicationID,
            })}?${new URLSearchParams(curQueries).toString()}`,
          )
        })
        .catch((error) => {
          snugNotifier.error('Error submitting ballot')
        })
        .finally(() => {
          this.setState({
            isBallotSubmitting: false,
          })
        })
    }
    if (fromSecondary) {
      acceptJointApplicationAsSecondary(
        finalisedApplicationID,
        applicantGUID,
        {
          applicantSummary: {},
          applicantDisclosure: {
            isPrimary: false,
            optedToAcceptCondition: true,
            propertyInspectionType: 2,
            optedToAcceptDisclosureConsent: true,
            isBallotEntry: true,
          },
        },
        true,
        {},
      )
        .then(() => {
          history.push(
            `${urlTo('applyConfirmationSummaryBallot', {
              applicationId: finalisedApplicationID,
            })}?${new URLSearchParams(curQueries).toString()}`,
          )
        })
        .catch((error) => {
          snugNotifier.error('Error submitting ballot')
        })
        .finally(() => {
          this.setState({
            isBallotSubmitting: false,
          })
        })
    }
  }

  switchOffModal = () => {
    this.setState({ modalOpen: false })
  }

  toggleGovtInfoLearnMoreModal = () => {
    const { isGovtInfoLearnMoreModalOpened } = this.state
    this.setState({
      isGovtInfoLearnMoreModalOpened: !isGovtInfoLearnMoreModalOpened,
    })
  }

  toggleModal = () => {
    const { modalOpen } = this.state
    this.setState({ modalOpen: !modalOpen })
  }

  update = (field) => {
    return (data) => {
      const currencyFields = [
        'governmentWeeklyBenefits',
        'governmentAnnualBenefits',
        'otherWeeklyIncome',
        'otherAnnualIncome',
        'optedToHavePropertyInvestor',
        'savingsBalance',
      ]
      if (!shouldCurrencyUpdate(currencyFields, field, data.value)) {
        return
      }
      this.setState({
        unsavedChanges: true,
        incomeValues: {
          ...this.state.incomeValues,
          [field]: data.value,
        },
        apiError: '',
        frontEndError: '',
        errors: {
          ...this.state.errors,
          [field]: data.error || '',
        },
      })
    }
  }

  toggleIncorrectReuploadModal = () => {
    const { isIncorrectReuploadModalOpen } = this.state
    this.setState({
      isIncorrectReuploadModalOpen: !isIncorrectReuploadModalOpen,
      incorrectDocuments: [{}],
    })
  }

  incorrectReuploadModalDelete = () => {
    this.deleteIncorrectDocuments()
  }

  deleteIncorrectDocuments = () => {
    const { incorrectDocuments } = this.state
    const { deleteProofOfIncome } = this.props
    incorrectDocuments?.forEach((document) => {
      if (document) {
        deleteProofOfIncome(document)
        this.toggleIncorrectReuploadModal()
      }
    })
  }

  secondaryActionIncorrectReuploadModal = () => {
    this.setState({
      isIncorrectReuploadModalOpen: false,
    })
    this.setState({ aiAnalysisModalOpen: true })
  }

  onClickConfirmOKForAnalysis = (analysisGUID) => {
    postRenterConfirmation(analysisGUID)
      .then(() => {
        this.getAIAnalysisOfDocs()
      })
      .catch((error) => {
        snugNotifier.error(error?.message)
      })
  }

  onClickUndoForAnalysis = (analysisGUID, confirmationGUID) => {
    undoRenterConfirmation(analysisGUID, confirmationGUID)
      .then(() => {
        this.getAIAnalysisOfDocs()
      })
      .catch((error) => {
        snugNotifier.error(error?.message)
      })
  }

  toggleProcessingDocumentsModal = () => {
    const { processingDocumentsModalOpen } = this.state
    this.setState({
      processingDocumentsModalOpen: !processingDocumentsModalOpen,
    })
  }

  toggleDocumentsViewer = (documentsViewerGUID = '') => {
    this.setState((prevState) => {
      const isClosing = prevState.showDocumentsViewer
      if (isClosing && prevState.stagedBankStatementViewerContext?.storageKey) {
        window.localStorage.removeItem(
          prevState.stagedBankStatementViewerContext.storageKey,
        )
      }
      return {
        showDocumentsViewer: !prevState.showDocumentsViewer,
        documentsViewerGUID:
          documentsViewerGUID || prevState.documentsViewerGUID,
        // Clear staged-session fields on close so the next open does not pick
        // them up via the `stagedDocumentsViewerAttachments || bankStatementViewerAttachments` fallback.
        ...(isClosing && {
          stagedDocumentsViewerAttachments: null,
          stagedBankStatementViewerContext: null,
        }),
      }
    })
  }

  saveManualBankStatementRedactions = ({ documentGuid, areas }) => {
    const { stagedBankStatementViewerContext } = this.state

    if (stagedBankStatementViewerContext?.propertyID && documentGuid) {
      return postStagedBankStatementManualRedactions(
        stagedBankStatementViewerContext.propertyID,
        documentGuid,
        areas,
      )
        .then(({ ok, result, responseText, statusText }) => {
          if (!ok) {
            return responseText.then((error) =>
              Promise.reject(translateErrorCodeToMessage(error || statusText)),
            )
          }

          if (!result?.redactedUrl) {
            return Promise.reject(REDACTED_STATEMENT_OPEN_FALLBACK_MESSAGE)
          }

          return postGenerateDownloadUrl(result.redactedUrl).then(
            ({
              ok: downloadOk,
              result: downloadResult,
              responseText: downloadErrorText,
              statusText: downloadStatusText,
            }) => {
              if (!downloadOk) {
                return downloadErrorText.then((error) =>
                  Promise.reject(
                    translateErrorCodeToMessage(error || downloadStatusText),
                  ),
                )
              }

              const nextContext = {
                ...stagedBankStatementViewerContext,
                redactedUrl:
                  result?.redactedUrl ||
                  stagedBankStatementViewerContext.redactedUrl,
              }

              window.localStorage.setItem(
                stagedBankStatementViewerContext.storageKey,
                JSON.stringify(nextContext),
              )

              this.setState({
                stagedBankStatementViewerContext: nextContext,
                stagedDocumentsViewerAttachments: [
                  {
                    url: downloadResult?.presignedUrl || '',
                    sourceUrl: nextContext.redactedUrl,
                    name:
                      stagedBankStatementViewerContext.filename ||
                      STAGED_BANK_STATEMENT_DEFAULT_FILENAME,
                    guidID: documentGuid,
                    redactionState: bankStatementRedactionStateReady,
                    typeOfDocument: 'Bank Statement',
                    translationPreview: null,
                  },
                ],
              })

              snugNotifier.success(REDACTED_BANK_STATEMENT_SAVED_MESSAGE)
              return Promise.resolve()
            },
          )
        })
        .catch((error) => {
          snugNotifier.error(error)
          return Promise.reject(error)
        })
    }

    return this.props
      .saveManualBankStatementRedactions(documentGuid, areas)
      .then(() => this.props.fetchProofOfIncome())
      .then(() => {
        snugNotifier.success(REDACTED_BANK_STATEMENT_SAVED_MESSAGE)
      })
      .catch((error) => {
        snugNotifier.error(error)
        return Promise.reject(error)
      })
  }

  renderNextPayMetric = () => {
    const report = this.state.financialInsightsReport
    if (!report) return null
    const display = formatNextPayLocal(report.nextPayDate, report.nextPayAmount)
    if (display == null) return null

    return (
      <div>
        <BankVerifiedMetricLabel>Next pay</BankVerifiedMetricLabel>
        <BankVerifiedMetricValue>{display}</BankVerifiedMetricValue>
      </div>
    )
  }

  renderBankAccountBlock = () => {
    const report = this.state.financialInsightsReport
    if (!report) return null
    const accountsAccessed = Array.isArray(report.accountsAccessed)
      ? report.accountsAccessed
      : []
    const primary = accountsAccessed[0] || null
    const bankName = report.bankName || primary?.bankName || ''
    const accountName = primary?.accountName || ''
    if (!bankName && !accountName) return null

    return (
      <BankVerifiedAccountBlock data-testid="fi-renter-v1-bank-account">
        <BankVerifiedAccountIcon src={bankIcon} alt="" aria-hidden="true" />
        <BankVerifiedAccountText>
          {bankName && (
            <BankVerifiedAccountBankName data-testid="fi-renter-v1-bank-name">
              {bankName}
            </BankVerifiedAccountBankName>
          )}
          {accountName && (
            <BankVerifiedAccountName data-testid="fi-renter-v1-account-name">
              {accountName}
            </BankVerifiedAccountName>
          )}
        </BankVerifiedAccountText>
      </BankVerifiedAccountBlock>
    )
  }

  renderMissingEssentialsMetric = () => {
    const report = this.state.financialInsightsReport
    if (!report) return null
    const label = getMissingEssentialsLabel(
      report.missingEssentialsGroceries,
      report.missingEssentialsTransport,
      report.missingEssentialsAccommodation,
    )
    return (
      <div>
        <BankVerifiedMetricLabel>Missing essentials</BankVerifiedMetricLabel>
        <BankVerifiedMetricValue>{label}</BankVerifiedMetricValue>
      </div>
    )
  }

  renderBankVerifiedCard = () => {
    const report = this.state.financialInsightsReport
    if (!report) return null
    const reportDate = report.reportCreatedAt
      ? new Date(report.reportCreatedAt)
      : null
    const reportDateText =
      reportDate && !isNaN(reportDate.getTime())
        ? reportDate.toLocaleDateString('en-AU', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
          })
        : null

    return (
      <BankVerifiedCard>
        <BankVerifiedHeader>
          <BankVerifiedHeaderLeft>
            <BankVerifiedCheckmark>&#10003;</BankVerifiedCheckmark>
            <BankVerifiedTitle>Income Verification</BankVerifiedTitle>
            {reportDateText && (
              <BankVerifiedSubtitle>
                Verified {reportDateText}
              </BankVerifiedSubtitle>
            )}
          </BankVerifiedHeaderLeft>
          <BankVerifiedBadge>Verified via Open Banking</BankVerifiedBadge>
        </BankVerifiedHeader>
        <BankVerifiedBody>
          {this.renderBankAccountBlock()}
          <BankVerifiedGrid>
            <MetricItem label="Monthly Income">
              {formatCurrency(report.avgMonthlyIncome)}
            </MetricItem>
            <MetricItem label="Total Savings">
              {formatCurrency(report.totalSavings)}
            </MetricItem>
            <MetricItem label="Monthly Rent">
              {formatCurrency(report.avgMonthlyRent)}
            </MetricItem>
            <MetricItem label="Rent-to-Income">
              {formatPercentage(report.rentToIncomeRatio)}
            </MetricItem>
            {report.weeklySurplusAfterRentAndFinances != null && (
              <MetricItem label="Weekly surplus after rent & commitments">
                {formatCurrency(report.weeklySurplusAfterRentAndFinances)} /wk
              </MetricItem>
            )}
            {report.incomeStabilityDuration != null && (
              <MetricItem label="Income stability">
                {report.incomeStabilityDuration}
              </MetricItem>
            )}
            {report.incomeConfidence != null && (
              <MetricItem label="Income confidence">
                {report.incomeConfidence}
              </MetricItem>
            )}
            {this.renderNextPayMetric()}
            {this.renderMissingEssentialsMetric()}
          </BankVerifiedGrid>
          <BankVerifiedFooter>
            <BankVerifiedRemoveButton
              type="button"
              disabled={this.state.financialInsightsDisconnecting}
              onClick={() => {
                this.setState({ financialInsightsDisconnecting: true })
                fetch(`${window.location.origin}/v2/financial-insights`, {
                  method: 'DELETE',
                  credentials: 'include',
                })
                  .then(() => {
                    this.setState({
                      financialInsightsCompleted: false,
                      financialInsightsReport: null,
                      financialInsightsDisconnecting: false,
                    })
                    // Refetch status so the audit tombstone surfaces immediately
                    // alongside the reconnect CTA — without this, the user is
                    // dropped to a bare Connect CTA until the next page load.
                    this.fetchFinancialInsightsStatus()
                  })
                  .catch((err) => {
                    logWarn('[FinancialInsights] disconnect failed', { err })
                    this.setState({
                      financialInsightsDisconnecting: false,
                    })
                  })
              }}
            >
              {this.state.financialInsightsDisconnecting
                ? 'Removing...'
                : 'Remove'}
            </BankVerifiedRemoveButton>
          </BankVerifiedFooter>
        </BankVerifiedBody>
      </BankVerifiedCard>
    )
  }

  renderBankConnectCta = () => {
    // The standalone V2 FI page needs an applicationId (or offerId) to satisfy
    // the listing-agency gate at session-create time. The V1 proof-of-income
    // form receives `applicationId` as a query parameter; forward it so the
    // BE can resolve the offer for the FI session via the application-access
    // port.
    const queries = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    const passthroughParams = []
    if (queries.applicationId) {
      passthroughParams.push(
        `applicationId=${encodeURIComponent(
          Array.isArray(queries.applicationId)
            ? queries.applicationId[0]
            : queries.applicationId,
        )}`,
      )
    }
    const passthroughQuery = passthroughParams.length
      ? `&${passthroughParams.join('&')}`
      : ''

    return (
      <BankConnectCta
        isRedirecting={this.state.isConnectBankRedirecting}
        onConnectClick={this.handleConnectBankClick}
        href={`/v2/sm/financial-insights?returnUrl=${encodeURIComponent(
          window.location.pathname + window.location.search,
        )}${passthroughQuery}`}
      />
    )
  }

  renderFinancialInsights = (isFromApplicationForm) => {
    const {
      financialInsightsAudit,
      financialInsightsEnabled,
      financialInsightsCompleted,
      financialInsightsReport,
    } = this.state

    // After consent expiry/revocation we surface BOTH the audit tombstone
    // (CDR obligation) and the reconnect CTA so the renter can immediately
    // re-attach a verified report without leaving the income screen.
    // Profile context (/sm/income with no application/agency in scope)
    // suppresses the reconnect CTA — there is no agency for a fresh
    // connection to attach to; reconnecting must happen from an
    // application flow.
    if (financialInsightsAudit) {
      return (
        <>
          <FinancialInsightsAuditCard audit={financialInsightsAudit} />
          {financialInsightsEnabled &&
            isFromApplicationForm &&
            this.renderBankConnectCta()}
        </>
      )
    }

    if (!financialInsightsEnabled) {
      return null
    }

    // !isRedacted matches the V2 BankConnectSummaryCard gate: when the FI
    // report has been redacted (CDR consent revoked / data deleted) we must
    // not surface stale verified data, even though the report row still
    // exists. Falls through to the reconnect CTA below.
    if (
      financialInsightsCompleted &&
      financialInsightsReport &&
      !financialInsightsReport.isRedacted
    ) {
      return this.renderBankVerifiedCard()
    }

    // Creation CTA is only valid from an application form (propertyId or applicationId in URL).
    // The profile page (/sm/income) shows existing connections but never creates a new one.
    if (!isFromApplicationForm) {
      return null
    }

    return this.renderBankConnectCta()
  }

  // eslint-disable-next-line react/sort-comp
  static loadBankStatementTranslationPreview = (s3Url = '') => {
    if (!s3Url) {
      return Promise.resolve(null)
    }

    return postGenerateTranslationPreview(s3Url)
      .then(({ ok, result }) => {
        if (!ok) {
          return null
        }

        return result || null
      })
      .catch((error) => {
        logWarn('[TranslationPreview] request failed:', error)
        return null
      })
  }

  // skipcq: JS-R1005 — pre-existing complexity in 2250-line legacy container; this PR slightly reduced it via FI helper extraction (renderFinancialInsights / renderBankVerifiedCard / renderBankConnectCta). Full reduction requires a dedicated refactor PR.
  render() {
    const {
      spinners,
      documents,
      addProofOfIncome,
      deleteProofOfIncome,
      responseTexts,
      backUrl,
      property,
      completeness,
      isQLDForm22,
    } = this.props
    const propertyId = getParameter('propertyId')
    const applicationId = getParameter('applicationId')
    const isFromApplicationForm = Boolean(propertyId || applicationId)
    const {
      modalOpen,
      newPaySlipsUpdated,
      newBankStatementsUpdated,
      newOtherStatementsAdded,
      newGovernmentBenefitDocumentAdded,
      otherIncomeTicked,
      governmentBenefitTicked,
      optedToHavePropertyInvestor,
      propertyInvestmentsContact,
      propertyInvestmentsInformation,
      propertyInvestmentsPostcodes = [],
      optedToHavePropertyOwnership,
      incomeValues: {
        otherWeeklyIncome,
        otherAnnualIncome,
        governmentWeeklyBenefits,
        governmentAnnualBenefits,
        savingsBalance,
      },
      errors: {
        otherWeeklyIncome: otherWeeklyIncomeError,
        otherAnnualIncome: otherAnnualIncomeError,
        governmentWeeklyBenefits: governmentWeeklyBenefitsError,
        governmentAnnualBenefits: governmentAnnualBenefitsError,
        optedToHavePropertyInvestor: optedToHavePropertyInvestorError,
        propertyInvestmentsContact: propertyInvestmentsContactError,
        propertyInvestmentsInformation: propertyInvestmentsInformationError,
        propertyInvestmentsPostcodes: propertyInvestmentsPostcodesError,
        propertyInvestmentsProfile: propertyInvestmentsProfileError,
        optedToHavePropertyOwnership: optedToHavePropertyOwnershipError,
        savingsBalance: savingsBalanceError,
      },
      unsavedChanges,
      disableNextButtonToFetchSettings,
      payslipsCountRequired,
      payslipsDurationRequired,
      payslipsMinDuration,
      agencyId,
      propertyInvestmentsProfile,
      isBallotApplication,
      isBallotSubmitModalOpen,
      isBallotSubmitting,
      isGovtInfoLearnMoreModalOpened,
      isIncorrectReuploadModalOpen,
      aiAnalysisModalOpen,
      aiAnalysisData,
      employmentHistoryNotPresentModalOpen,
      employmenthistoryModalSkipped,
      processingDocumentsModalOpen,
      showDocumentsViewer,
      documentsViewerGUID,
      stagedDocumentsViewerAttachments,
    } = this.state
    const { applicationsSettingsConfig, effectiveConfig } =
      this.getEffectiveBankStatementConfig()

    const {
      payslips_require_number: payslipsRequiredNumber = 0,
      payslips_require: payslipsRequired = false,
      bank_statement_require_type: bankStatementRequireType = 0,
      bank_statement_require: bankStatementRequire = false,
      bank_statement_require_recent_two: bankStatementRequireRecentTwo = false,
    } = applicationsSettingsConfig || {}
    const { teamName = '', address } = property || {}
    let payslipsNumber = 0
    let bankStatementsOptions = ''

    if (payslipsRequired) {
      payslipsNumber = payslipReqOptions[payslipsRequiredNumber || 0]
    }

    if (bankStatementRequire) {
      bankStatementsOptions =
        requireBankStatementOptionsMap[bankStatementRequireType || 0]
    }

    // Determine if bank statements section should be rendered
    const showBankStatements = shouldRenderBankStatements(effectiveConfig)

    // Determine if bank statements should be validated (same as render visibility)
    const shouldValidateBankStatements = showBankStatements

    const newIncomeUpdate =
      newPaySlipsUpdated ||
      newBankStatementsUpdated ||
      newOtherStatementsAdded ||
      newGovernmentBenefitDocumentAdded
    const incomeUpdateTagClass = newIncomeUpdate ? 'renter-income-added' : ''
    const bankStatementPeriodNumber = bankStatementRequireRecentTwo ? 2 : 1
    const bankStatementDocuments = getBankStatementDocumentsForDisplay(
      documents.bankStatements,
    )

    const bankStatementRequirementMessage = `${teamName} requires ${
      bankStatementRequireRecentTwo
        ? ` two (2) recent Bank Statements`
        : ' a Bank Statement'
    }${bankStatementsOptions}.`

    const {
      section: {
        income: {
          checkPayslips: applyRuleCheckPayslips = false,
          smartDocsForRentersEnabled = false,
        } = {},
      } = {},
    } = this.props.applyRules || {}

    const enforcePayslipRequirements =
      payslipsRequired && applyRuleCheckPayslips
    const bankStatementViewerAttachments = (
      documents?.bankStatements || []
    ).map((document) => ({
      url: document?.URL || document?.url || '',
      sourceUrl: document?.URL || document?.url || '',
      name: document?.name || '',
      guidID: document?.guidID || '',
      redactionState: document?.redactionState || '',
      typeOfDocument: 'Bank Statement',
      isAutoDeleted: document?.isAutoDeleted,
      fileAutoDeletedAt: document?.fileAutoDeletedAt,
    }))
    const documentsViewerAttachments =
      stagedDocumentsViewerAttachments || bankStatementViewerAttachments
    const hasManualRedactionAttachment = documentsViewerAttachments.some(
      (document) =>
        document?.redactionState === bankStatementRedactionStateReady ||
        document?.url?.includes('bank-redacted'),
    )

    let payslipsGuidance = applicationText(isQLDForm22, incomePayslipsGuidance)
    if (
      payslipsDurationRequired &&
      !!payslipsMinDuration &&
      enforcePayslipRequirements &&
      !isQLDForm22
    ) {
      payslipsGuidance =
        textHelpers.incomePayslipsDurationRecommendTxt(payslipsMinDuration)
    }

    return (
      <Display.CenterContentContainer componentClass="width100">
        <div className="proof-of-income">
          <ProgressBarComponent
            completeness={completeness}
            clickNextFunctionFromParentComponent={() =>
              this.checkProofOfIncomeBeforeNext(
                payslipsNumber,
                bankStatementPeriodNumber,
                enforcePayslipRequirements,
              )
            }
          />
          <RentalReputationHeaderReminder
            property={property}
            backUrl={backUrl}
            remindText={'Current application'}
            isFromApplicationForm={isFromApplicationForm}
            title="Income"
          />

          <Header
            title="Income"
            message={
              <>
                {isBallotApplication && <BallotAlertDocumentUpload />}
                <p className="gray-color mb0">
                  {applicationText(isQLDForm22, incomeHeaderGuidance)}
                </p>
              </>
            }
          />

          <AlertSensitiveInfo />
          {this.renderFinancialInsights(isFromApplicationForm)}
        </div>
        <div className="content">
          <div className="row">
            <div className="col-xs-12">
              <h3 className="mt15">
                <Flex>
                  <Box mr={3}>Payslips</Box>
                  {smartDocsForRentersEnabled && (
                    <img
                      src={BaseIconAI}
                      alt="SmartDocs AI Icon"
                      width={theme.width[6] + 'px'}
                      height={theme.height[6] + 'px'}
                    />
                  )}
                </Flex>
              </h3>
              <p className="mt15 mb25">{payslipsGuidance}</p>
              {enforcePayslipRequirements && (
                <Alert
                  showLeftIcon={true}
                  leftIconVariant="info"
                  variant="blueWithBg"
                  fontSize={theme.fontSizes.pRegular14}
                >
                  {teamName} requires {payslipsNumber} payslips
                </Alert>
              )}
              {smartDocsForRentersEnabled && (
                <Box my={4}>
                  <SmartDocsAlertBox />
                </Box>
              )}
              <DocumentList
                documents={documents.paySlips}
                addDocument={(documentType, fileType) =>
                  addProofOfIncome(documentType, fileType, agencyId)
                }
                deleteDocument={deleteProofOfIncome}
                documentType={DocumentTypes.Payslips}
                spinner={spinners.Payslips}
                responseText={responseTexts.Payslips}
                fileType="Payslips"
                setDocumentsChanged={this.setPaySlipsChanged}
                allowDeletion={true}
                executeAfterSuccessfulUpload={this.executeAfterSuccessfulUpload}
                disableMultiple={true}
              />
            </div>
          </div>
          {showBankStatements && (
            <div className="row">
              <div className="col-xs-12 mt25">
                <h3 className="mb15">Bank Statements</h3>
                <p>{applicationText(isQLDForm22, incomeBankStatement)}</p>
                {bankStatementRequire && (
                  <Alert
                    showLeftIcon={true}
                    leftIconVariant="info"
                    variant="blueWithBg"
                    fontSize={theme.fontSizes.pRegular14}
                    mb={4}
                  >
                    {bankStatementRequirementMessage}
                  </Alert>
                )}

                {!isQLDForm22 && showBankStatements && (
                  <>
                    <Box lineHeight="1.6">
                      <SystemText as="strong">Savings balance</SystemText>
                      <br />
                      <SystemText as="span">
                        Add a Savings Balance to show affordability (useful if
                        retired or not currently working).
                      </SystemText>
                    </Box>
                    <Input
                      prefix="$"
                      error={savingsBalanceError}
                      inputProps={{
                        placeholder: 'e.g. 5000',
                        value: savingsBalance,
                        onChange: (e) =>
                          this.update('savingsBalance')(e.target),
                        maxWidth: '90px',
                        maxHeight: '20px',
                      }}
                      containerProps={{
                        width: '130px',
                        height: '40px',
                        marginBottom: '24px',
                        marginTop: '16px',
                      }}
                    />
                    <ErrorBox
                      showError={!!savingsBalanceError}
                      error={savingsBalanceError}
                    />
                  </>
                )}

                <DocumentList
                  documents={bankStatementDocuments}
                  addDocument={(documentType, fileType) =>
                    addProofOfIncome(documentType, fileType, agencyId)
                  }
                  deleteDocument={(id, fileType) =>
                    deleteProofOfIncome(id, fileType, agencyId)
                  }
                  documentType={DocumentTypes.BankStatements}
                  spinner={spinners.BankStatements}
                  responseText={responseTexts.BankStatements}
                  fileType="BankStatements"
                  setDocumentsChanged={this.setBankStatementsChanged}
                  allowDeletion={true}
                  toggleDocumentsViewer={this.toggleDocumentsViewer}
                  shouldToggleDocumentsViewer={
                    shouldOpenBankStatementInDocumentsViewer
                  }
                />
              </div>
            </div>
          )}
          <div className="mt25">
            <Form.Checkbox
              label="I have other sources of income"
              checked={otherIncomeTicked}
              onChange={() => this.onCheckBoxTicked('otherIncomeTicked')}
            />
            {otherIncomeTicked && (
              <div>
                <h3 className="mt25 mb15">Other Income Statements</h3>
                <div className="mb10">
                  <DocumentList
                    documents={documents.otherIncomeDocuments}
                    addDocument={addProofOfIncome}
                    deleteDocument={deleteProofOfIncome}
                    documentType={DocumentTypes.OtherIncomeDocuments}
                    spinner={spinners.OtherIncomeDocuments}
                    responseText={responseTexts.OtherIncomeDocuments}
                    fileType="OtherIncomeDocuments"
                    setDocumentsChanged={this.setOtherIncomeStatementsChanged}
                    allowDeletion={true}
                  />
                </div>
                <NewForm.ProfilePagesRowLayout containerClass="profile-layout-two-items">
                  <NewForm.InputTextOptional
                    label={Text.placeholder.otherWeeklyIncomePlaceholder}
                    value={otherWeeklyIncome}
                    error={otherWeeklyIncomeError}
                    onChange={this.update('otherWeeklyIncome')}
                    id="otherWeeklyIncome"
                    inputClass="width100"
                    componentClass="margin-profile-item-left width100"
                    labelClass="top20 small-label"
                    isOptional={!otherIncomeTicked}
                  />
                  <NewForm.InputTextOptional
                    label={Text.placeholder.otherAnnualIncomePlaceholder}
                    value={otherAnnualIncome}
                    error={otherAnnualIncomeError}
                    onChange={this.update('otherAnnualIncome')}
                    id="otherAnnualIncome"
                    inputClass="width100"
                    componentClass="margin-profile-item-right width100"
                    labelClass="top20 small-label"
                    isOptional={!otherIncomeTicked}
                  />
                </NewForm.ProfilePagesRowLayout>
              </div>
            )}
          </div>
          <div className="mt25">
            <Form.Checkbox
              label="I receive Government benefits"
              checked={governmentBenefitTicked}
              onChange={() => this.onCheckBoxTicked('governmentBenefitTicked')}
            />
            {governmentBenefitTicked && (
              <div>
                <h3 className="mt25 mb15">
                  Services Australia/Government Benefits
                </h3>
                <p>
                  {applicationText(isQLDForm22, incomeGorvenmentBenefitTicked)}
                </p>
                <div className="mb10">
                  <DocumentList
                    documents={documents.governmentBenefitDocuments}
                    addDocument={addProofOfIncome}
                    deleteDocument={deleteProofOfIncome}
                    documentType={DocumentTypes.GovernmentBenefitDocuments}
                    spinner={spinners.GovernmentBenefitDocuments}
                    responseText={responseTexts.GovernmentBenefitDocuments}
                    fileType="GovernmentBenefitDocuments"
                    setDocumentsChanged={
                      this.setGovernmentBenefitDocumentChanged
                    }
                    allowDeletion={true}
                  />
                </div>
                <p className="gray-color mb10">
                  {Text.placeholder.governmentBenefitsLabel}
                  <Button
                    variant="linkBlueWithoutWeight"
                    onClick={() => this.toggleGovtInfoLearnMoreModal()}
                    ml={1}
                  >
                    learn more
                  </Button>
                </p>
                <NewForm.ProfilePagesRowLayout containerClass="profile-layout-two-items">
                  <NewForm.InputTextOptional
                    label={Text.placeholder.governmentWeeklyBenefitsPlacehold}
                    value={governmentWeeklyBenefits}
                    error={governmentWeeklyBenefitsError}
                    onChange={this.update('governmentWeeklyBenefits')}
                    id="governmentWeeklyBenefits"
                    inputClass="width100"
                    componentClass="margin-profile-item-left width100"
                    labelClass="top20 small-label"
                    isOptional={!governmentBenefitTicked}
                  />
                  <NewForm.InputTextOptional
                    label={Text.placeholder.governmentAnnualBenefitsPlacehold}
                    value={governmentAnnualBenefits}
                    error={governmentAnnualBenefitsError}
                    onChange={this.update('governmentAnnualBenefits')}
                    id="governmentAnnualBenefits"
                    inputClass="width100"
                    componentClass="margin-profile-item-right width100"
                    labelClass="top20 small-label"
                    isOptional={!governmentBenefitTicked}
                  />
                </NewForm.ProfilePagesRowLayout>
              </div>
            )}
          </div>
          {!isBallotApplication && (
            <Alert showLeftIcon={false} variant="blueWithBg" mt={7}>
              <Box className="width100" color="darkGray">
                <h3 className="mb15">
                  Property Investment (optional marketing promotion)
                </h3>
                <p>
                  Add optional Profile info, unrelated to application, to
                  receive more information.
                </p>

                <Form.RadioGroup
                  label="Do you have existing or planned property investments?"
                  id="optedToHavePropertyInvestor"
                  field="optedToHavePropertyInvestor"
                  componentClassName="property-details-radio-group"
                  error={optedToHavePropertyInvestorError}
                >
                  <Form.Checkbox
                    id={Yes}
                    label="Yes"
                    checked={optedToHavePropertyInvestor === Yes}
                    onChange={(e) => this.onChangePropertyInvestor()(e)}
                  />
                  <Form.Checkbox
                    id={No}
                    label="No"
                    checked={optedToHavePropertyInvestor === No}
                    onChange={(e) => this.onChangePropertyInvestor()(e)}
                  />
                </Form.RadioGroup>

                {optedToHavePropertyInvestor === Yes && (
                  <>
                    <SystemText mb="0">
                      Select your investment profile.
                    </SystemText>
                    <SelectInvestmentProfile
                      propertyInvestmentsProfile={propertyInvestmentsProfile}
                      onChangeInvestmentProfile={this.onChangeInvestmentProfile}
                      propertyInvestmentsProfileError={
                        propertyInvestmentsProfileError
                      }
                    />

                    <SystemText mb="0">
                      Which postcode(s) do you have existing and/or planned
                      investments?
                    </SystemText>
                    <Box width="283px" mb="16px" backgroundColor={'white'}>
                      <StyledTagsInput
                        error={propertyInvestmentsPostcodesError?.length}
                      >
                        <TagsInput
                          value={propertyInvestmentsPostcodes}
                          changeHandler={(tags) =>
                            this.onChangePostcodesInput(tags)
                          }
                          inputPlaceholder={'Add postcode and press Enter'}
                        />
                      </StyledTagsInput>
                    </Box>

                    <Form.RadioGroup
                      label="Would you like to be contacted about property investment or management services by the real estate agent?"
                      id="propertyInvestmentsContact"
                      field="propertyInvestmentsContact"
                      componentClassName="property-details-radio-group"
                      error={propertyInvestmentsContactError}
                    >
                      <Form.Checkbox
                        id={TRUE}
                        label="Yes"
                        checked={propertyInvestmentsContact === TRUE}
                        onChange={(e) =>
                          this.onChangePropertyInvestmentContact()(e)
                        }
                      />

                      <Form.Checkbox
                        id={FALSE}
                        label="No"
                        checked={propertyInvestmentsContact === FALSE}
                        onChange={(e) =>
                          this.onChangePropertyInvestmentContact()(e)
                        }
                      />
                    </Form.RadioGroup>
                    <Form.RadioGroup
                      label="Would you like to receive information about property investment opportunities and related services?"
                      id="propertyInvestmentsContact"
                      field="propertyInvestmentsContact"
                      componentClassName="property-details-radio-group"
                      error={propertyInvestmentsInformationError}
                    >
                      <Form.Checkbox
                        id={TRUE}
                        label="Yes"
                        checked={propertyInvestmentsInformation === TRUE}
                        onChange={(e) =>
                          this.onChangePropertyInvestmentInformation()(e)
                        }
                      />

                      <Form.Checkbox
                        id={FALSE}
                        label="No"
                        checked={propertyInvestmentsInformation === FALSE}
                        onChange={(e) =>
                          this.onChangePropertyInvestmentInformation()(e)
                        }
                      />
                    </Form.RadioGroup>
                  </>
                )}
              </Box>
            </Alert>
          )}
          {isBallotApplication && (
            <div className="mt25 width100">
              <h3 className="mb15">Property Ownership</h3>
              <Form.RadioGroup
                label="Do you own a whole or part of a property in Australia?"
                id="optedToHavePropertyOwnership"
                field="optedToHavePropertyOwnership"
                componentClassName="property-details-radio-group"
                error={optedToHavePropertyOwnershipError}
              >
                <Form.Checkbox
                  id={Yes}
                  label="Yes"
                  checked={optedToHavePropertyOwnership === Yes}
                  onChange={(e) => this.onChangePropertyOwnership()(e)}
                />
                <Form.Checkbox
                  id={No}
                  label="No"
                  checked={optedToHavePropertyOwnership === No}
                  onChange={(e) => this.onChangePropertyOwnership()(e)}
                />
              </Form.RadioGroup>
            </div>
          )}
          <Display.BottomContentContainer>
            <Display.CenterContentContainer componentClass="width100">
              <div className="submit-button-container">
                <BottomButton
                  clickNextFunction={() =>
                    this.checkProofOfIncomeBeforeNext(
                      payslipsNumber,
                      bankStatementPeriodNumber,
                      enforcePayslipRequirements,
                    )
                  }
                  btnText={
                    isFromApplicationForm ? (
                      <span>
                        Save & Continue
                        <i
                          className={`${
                            isFromApplicationForm && agencyId !== ''
                              ? disableNextButtonToFetchSettings
                                ? 'fa fa-spinner'
                                : ''
                              : ''
                          }`}
                        />
                      </span>
                    ) : (
                      'Next: Identity Document'
                    )
                  }
                  bottomButtonsClass="pt0 mt0 summary-bottom-button"
                  nextBtnClass={`summary-green-button-class p0 ${incomeUpdateTagClass}`}
                  backButtonClass="summary-grey-button-class"
                  nextButtonPositionClass="pr20 pl0"
                  showArrow={false}
                  nextBtnDisabled={
                    isFromApplicationForm
                      ? disableNextButtonToFetchSettings
                      : false
                  }
                />
              </div>
            </Display.CenterContentContainer>
          </Display.BottomContentContainer>
          {modalOpen && (
            <WarningModal
              docs={documents}
              isPayslipsCountRequired={payslipsCountRequired}
              isBankStatementRequired={bankStatementRequire}
              isPayslipsDurationRequired={payslipsDurationRequired}
              isOtherDocsTicked={otherIncomeTicked}
              isGovDocsTicked={governmentBenefitTicked}
              payslipsDuration={payslipsMinDuration}
              savingsBalance={savingsBalance}
              onPrimaryClick={() => this.toggleModal()}
              onSecondaryClick={(allowContinue) =>
                allowContinue
                  ? this.onModalSecondaryButtonClick()
                  : this.toggleModal()
              }
              payslipsNumber={payslipsNumber}
              bankStatementPeriodNumber={bankStatementPeriodNumber}
              shouldValidateBankStatements={shouldValidateBankStatements}
            />
          )}
          {isBallotSubmitModalOpen && (
            <BallotSubmitModal
              toggleModal={this.toggleBallotSubmitModal}
              primaryAction={this.submitBallotApplication}
              submitLoading={isBallotSubmitting}
            />
          )}
          {isGovtInfoLearnMoreModalOpened && (
            <Modal
              modalBody={Text.placeholder.governmentBenefitsInfoModalText}
              toggleModal={() => this.toggleGovtInfoLearnMoreModal()}
              showPrimaryButton={false}
              secondaryLabel="Close"
              secondaryAction={() => this.toggleGovtInfoLearnMoreModal()}
            />
          )}
          {aiAnalysisModalOpen && (
            <CorrectDocumentModal
              toggleModal={this.toggleAIAnalysisModal}
              analysisResult={aiAnalysisData}
              isCopilot={false}
              onClickConfirmOKForAnalysis={this.onClickConfirmOKForAnalysis}
              onClickUndoForAnalysis={this.onClickUndoForAnalysis}
            />
          )}
          {isIncorrectReuploadModalOpen && (
            <IncorrectDocumentReuploadModal
              toggleModal={this.toggleIncorrectReuploadModal}
              primaryAction={this.incorrectReuploadModalDelete}
              secondaryAction={this.secondaryActionIncorrectReuploadModal}
            />
          )}
          {employmentHistoryNotPresentModalOpen && (
            <EmpHistoryNotPresentModal
              isSkipped={employmenthistoryModalSkipped}
              toggleModal={this.toggleEmploymentHistoryNotPresentModal}
              secondaryAction={this.empHistoryNotPresentModalSecondaryAction}
              primaryAction={this.empHistoryNotPresentModalPrimaryAction}
            />
          )}
          {processingDocumentsModalOpen && (
            <ProcessingDocuments
              toggleModal={this.toggleProcessingDocumentsModal}
            />
          )}
          {showDocumentsViewer && (
            <DocumentsViewer
              toggleDocumentsViewer={this.toggleDocumentsViewer}
              documentsViewerGUID={documentsViewerGUID}
              documentViewerAttachments={documentsViewerAttachments}
              enableManualRedaction={hasManualRedactionAttachment}
              hidePrintButton={hasManualRedactionAttachment}
              loadTranslationPreview={
                ProofOfIncome.loadBankStatementTranslationPreview
              }
              onSaveManualRedactions={this.saveManualBankStatementRedactions}
              onClickConfirmOKForAnalysis={this.onClickConfirmOKForAnalysis}
              onClickUndoForAnalysis={this.onClickUndoForAnalysis}
            />
          )}
        </div>
        <UnsavedMessage unsavedChanges={unsavedChanges} />
      </Display.CenterContentContainer>
    )
  }
}

export default ProofOfIncome
